export function splitWorkspace(dir: string | undefined) {
  if (!dir) return { root: "", id: undefined as string | undefined }
  let decoded = dir
  try {
    decoded = decodeURIComponent(dir)
  } catch (_e) {
    // leave as is
  }
  if (decoded.startsWith("ws_")) {
    return { root: "", id: decoded }
  }
  const [root, id] = decoded.split("?workspace=")
  return { root, id: id || undefined }
}

export function workspaceHeaders(directory: string | undefined, workspaceID?: string) {
  if (workspaceID) return { "x-mux-workspace": workspaceID }
  if (!directory) return {}
  const split = splitWorkspace(directory)
  if (split.id) return { "x-mux-workspace": split.id }
  return { "x-mux-directory": directory }
}

export function joinWorkspace(root: string, id?: string) {
  return id || root
}

export function stripWorkspace(dir: string | undefined) {
  return splitWorkspace(dir).root
}
